import apiFetch from '../apiFetch'

export default function (idEntradaAlmacen, token) {
  return apiFetch({endPoint: `EntradaAlmacen/getEntradaAlmacen?idEntradaAlmacen=` + idEntradaAlmacen, method: 'GET', body: null, token: token})
}